module.exports = __webpack_public_path__ + "img/t_dc.d092a4b9.svg";